export const sideBarState = (state) => {
    return state.sideBar;
};